type Props = { type: string | null | undefined };

// Visual badge for StatutoryCertType#statutory_type enum ("statutory" /
// "mandatory" / "other"). Colours deliberately distinct from the HPAC
// brand green so they read as data labels, not interactive elements.
export default function TypeBadge({ type }: Props) {
  if (!type) return <span className="text-slate-400 text-xs">—</span>;

  const normalised = String(type).toLowerCase();
  const cls =
    normalised === "statutory"
      ? "bg-teal-50 text-teal-700 border-teal-200"
      : normalised === "mandatory"
        ? "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200"
        : "bg-slate-100 text-slate-700 border-slate-200";

  return (
    <span className={`inline-block px-1.5 py-0.5 text-[10px] rounded border uppercase tracking-wide ${cls}`}>
      {normalised}
    </span>
  );
}
